const { h, render, Component } = require('preact');

class CardInfo extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <table class="remaining-tables">
        <tr>
          <td>
            {(this.props.orderDetails.purchaseHistory.firstPayment.name) &&
              <span>({this.props.orderDetails.purchaseHistory.firstPayment.name})</span>
            }
          </td>
          <td></td>
        </tr>
      </table>
    );
  }
}
module.exports = CardInfo
